import { Circle, Polyline, Svg } from '@react-pdf/renderer';

const CheckMark = () => (
  <Svg width="14.8px" height="14.8px" viewBox="0 0 24 24">
    {/* Krug s pozadinom */}
    <Circle cx="12" cy="12" r="9" fill="#7da13b" />

    {/* Kvačica unutar kruga */}
    <Polyline
      points="8 11.5 11 14.5 16 9.5"
      fill="none"
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.152"
    />
  </Svg>
);

export default CheckMark;
